import { render, staticRenderFns } from "./BarChartHorizontal.vue?vue&type=template&id=2b90b3b0&scoped=true&"
import script from "./BarChartHorizontal.vue?vue&type=script&lang=js&"
export * from "./BarChartHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./BarChartHorizontal.vue?vue&type=style&index=0&id=2b90b3b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b90b3b0",
  null
  
)

export default component.exports